import axios from 'axios';
import querystring from 'qs';
import moment from 'moment';

export default {
    name: 'MonthView',
    props: {

    },
    computed: {

    },
    data() {
        return {
            initialized: false,
            monthyear: moment().format('YYYY-MM'),
            list: [],
            attendantId: 0,
            weekdays: [
                this.$t('periods.long.monday'),
                this.$t('periods.long.tuesday'),
                this.$t('periods.long.wednesday'),
                this.$t('periods.long.thursday'),
                this.$t('periods.long.friday'),
                this.$t('periods.long.saturday'),
                this.$t('periods.long.sunday')
            ],
            result: {
                totalHours: 0,
                scheduleHours: 0,
                difference: 0
            }
        };
    },
    watch: {
        monthyear() {
            this.fetch();
        },
        attendantId() {
            this.fetch();
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {

        fetch() {
            //console.log('monthview');
            if (this.attendantId > 0) {
                let month = this.monthyear.split("-")[1];
                let year = this.monthyear.split("-")[0];
                this.initialized = false;
                let url = APIURL + `/attendantactivity/month/${year}/${month}/${this.attendantId}`;
                let response = axios.get(url)
                    .then(resp => {
                        this.result = resp.data;
                        this.list = this.result.result;

                    });
                Promise.all([response])
                    .then(() => {
                        this.initialized = true;
                    })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
            }
            else {
                this.initialized = true;
            }
        },
        getdaycss(date) {
            let cssclass = '';
            let now = moment();
            let datemoment = moment(date);
            if (now.format('M') == datemoment.format('M')) {
                cssclass = 'outside';
            }
            if (now.format('D') == datemoment.format('D') && now.format('M') == datemoment.format('M')) {
                cssclass = 'today';
            }
            return cssclass;
        }
        
    }
};